import whichEnv from '@ally/which-env'

const forgotPasswordPathname =
  '/auto/online-services/access/forgot-password-user-identification.html'
const forgotUsernamePathname =
  '/auto/online-services/access/forgot-user-name.html'

const getBaseUrl = (): string => {
  return whichEnv(window.location.href).pick({
    local: `https://www-cit2.ally.com`,
    dev: `https://www-cit2.ally.com`,
    qa1: 'https://www-uat2.ally.com',
    qa2: 'https://www-uat2.ally.com',
    qa3: 'https://www-uat2.ally.com',
    cap: 'https://www-cap.int.ally.com',
    psp: 'https://www-prodsupt.ally.com',
    prod: 'https://www.ally.com',
  })
}

const getAAOSForgotPasswordUrl = (): string => {
  return `${getBaseUrl()}${forgotPasswordPathname}`
}

const getAAOSForgotUsernameUrl = (): string => {
  return `${getBaseUrl()}${forgotUsernamePathname}`
}

export { getAAOSForgotPasswordUrl, getAAOSForgotUsernameUrl }
